import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditAccessRestrictionsRequestFailure() {
      return getState().isFailure;
    },
    isEditAccessRestrictionsRequestPending() {
      return getState().isPending;
    },
    isEditAccessRestrictionsRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
